import React, { useState, useEffect } from "react";
import { Button, Table } from "reactstrap";
import { LoadingMessage } from "../../Controls";
import { DateField } from "../../../../utils";
import { addMonth } from "./../../../Modal/ActivityV2/helper";
import { FormattedDate } from "react-intl";
import style from "./styles.module.scss";
import ModalCreditRating from "../../Modals/ModalCreditRating";
import LaddaButton, { ZOOM_OUT, XS, SLIDE_LEFT } from "react-ladda";

const Agencies = ({ assetId, services, wizzToggle, wizzOnChange, role }) => {
  const [agencies, setAgencies] = useState(false);
  const [active, setActive] = useState(false);
  const [filter, setFilter] = useState({
    FromDate: addMonth(new Date(), -31).toString(),
    ToDate: new Date().toString(),
  });

  const [modalCreditRating, setModalCreditRating] = useState({ open: false });
  const [ratingAgencies, setRatingAgencies] = useState([]);

  const toggleModalCreditRating = (props) =>
    setModalCreditRating({ open: !modalCreditRating.open, ...props });

  const assignAssetQuoteCreditRating = (payload) => {
    if (services.assignAssetCreditRating) {
      return services.assignAssetCreditRating(payload).then(({ response }) => {
        if (response.result.Code != 200) {
          wizzToggle("message", {
            title: "Error",
            message: response.result.Description,
          });
        }
        return response.result.Code;
      });
    }
  };

  useEffect(() => {
    services.getAgencies &&
      services.getAgencies().then(({ response }) => {
        if (response && response.result && response.result.Code == 200) {
          const { agencies } = response;
          setRatingAgencies(agencies);
        }
      });
  }, []);

  useEffect(() => {
    getAgencies(filter);
  }, [filter]);

  const getAgencies = (filter) => {
    setAgencies(false);
    setActive(false);
    services.creditsRatings({ assetId, filter }).then(({ result, creditsRatings }) => {
      setAgencies(creditsRatings);
    });
  };

  const handleDelete = (agency) => {
    const request = {
      assetId: assetId,
      quoteDate: agency.CreditRatingAgencyDate,
    };

    services.deleteAssetCreditRating &&
      services.deleteAssetCreditRating(request).then(({ response }) => {
        if (response && response.result && response.result.Code == 200) {
          setAgencies((prevState) => {
            return prevState.filter((currentAgency) => {
              return currentAgency.Date !== agency.CreditRatingAgencyDate;
            });
          });
        }
      });
  };

  return (
    <div>
      <div className={style.filter}>
        <div className={style.filterContainer}>
          <div className={style.field}>
            <div className={style.label}>From Date</div>
            <div className={style.formDate}>
              <DateField
                disabled={false}
                label=""
                name="FromDate"
                onChange={(name, value) => setFilter({ ...filter, FromDate: value })}
                value={filter.FromDate || new Date().toLocaleDateString("en")}
              />
            </div>
          </div>
          <div className={style.field}>
            <div className={style.label}>To Date</div>
            <div className={style.formDate}>
              <DateField
                disabled={false}
                label=""
                name="ToDate"
                onChange={(name, value) => setFilter({ ...filter, ToDate: value })}
                value={filter.ToDate || new Date().toLocaleDateString("en")}
              />
            </div>
          </div>
        </div>
        {role == "trader" && (
          <Button color="primary" className="mb-3 mx-2" onClick={() => setModalCreditRating({ open: true })}>
            <i className="fa fa-plus mr-1" aria-hidden="true"></i>
            Add Credit Rating
          </Button>
        )}
      </div>
      <Table className={style.agencies} hover>
        <thead>
          <tr>
            <th></th>
            <th>Date</th>
            <th>Agency detail</th>
          </tr>
        </thead>
        <tbody>
          {agencies ? (
            <React.Fragment>
              {agencies.map((date) => (
                <React.Fragment>
                  {date.Agencies.map((ag, index) => (
                    <React.Fragment>
                      <tr
                        className="cursor-pointer"
                        key={`ag-${ag.CreditRatingAgencyId}-${ag.CreditRatingAgencyDate}`}
                        onClick={() => setActive(active === getRowKey(ag, index) || getRowKey(ag, index))}
                      >
                        <td>
                          <span>
                            {active === getRowKey(ag, index) ? (
                              <i className="icon-arrow-down icons font-1lg mt-1 d-block"></i>
                            ) : (
                              <i className="icon-arrow-right icons font-1lg mt-1 d-block"></i>
                            )}
                          </span>
                        </td>
                        <td>
                          <FormattedDate value={ag.CreditRatingAgencyDate} />
                        </td>
                        <td>{ag.CreditRatingAgencyName}</td>
                        <td>
                          {role == "trader" && (
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                              <LaddaButton
                                className="btn btn-ladda btn-danger btn-sm"
                                loading={false}
                                onClick={() => {
                                  wizzToggle("confirm", {
                                    title: "Delete Credit Rating",
                                    message: "Are you sure you want to delete credit rating?",
                                    onConfirm: () => handleDelete(ag),
                                  });
                                }}
                                data-style={ZOOM_OUT}
                                data-size={XS}
                              >
                                <i className="fa fa-trash-o" aria-hidden="true"></i>
                              </LaddaButton>
                            </div>
                          )}
                        </td>
                      </tr>
                      {active === getRowKey(ag, index) && (
                        <tr>
                          <td colSpan="3" className="p-0">
                            <Scores scores={ag.Scores} />
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
              {agencies.length == 0 && <EmptyOrLoading />}
            </React.Fragment>
          ) : (
            <EmptyOrLoading loading />
          )}
        </tbody>
      </Table>
      {modalCreditRating.open && (
        <ModalCreditRating
          {...modalCreditRating}
          assetId={assetId}
          toggle={toggleModalCreditRating}
          agencies={ratingAgencies}
          onConfirm={assignAssetQuoteCreditRating}
          getAgencies={() => getAgencies(filter)}
          services={services}
        />
      )}
    </div>
  );
};

const Scores = ({ scores }) => (
  <div className={style.scores}>
    <Table>
      <thead>
        <th>Score</th>
        <th>Score value</th>
      </thead>
      <tbody>
        {scores.map((score) => (
          <tr key={`score-${score.CreditRatingAgencyScore}`}>
            <td>{score.CreditRatingAgencyScore}</td>
            <td>{score.CreditRatingAgencyScoreValue}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);

function getRowKey(agency, index) {
  return `${agency.CreditRatingAgencyId}-${agency.CreditRatingAgencyDate}-${index}`;
}

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="7" className="bg-white">
      {loading ? (
        <LoadingMessage text="Loading agencies credits ratings" />
      ) : (
        <span className="text-center d-block h5 m-3 mt-4">No asset agencies data</span>
      )}
    </td>
  </tr>
);

export default Agencies;
